export function hide(obj){ 
	if(document.getElementById(obj).className=="yin_1"){
		jq_1_7_1(".cy_wzaTool_bg_table ul li dl.xian_1").removeClass("xian_1").addClass("yin_1");
		document.getElementById(obj).className="xian_1";
		
	}else{
		//document.getElementById(obj).className="yin_1";
		jq_1_7_1(".cy_wzaTool_bg_table ul li dl.xian_1").removeClass("xian_1").addClass("yin_1");
	}
}

function findvar(obj,sz){   
	var b = false;
	for (var i = 0; i < sz.length; i++) {
		if (sz[i] == obj) {
			b = true;
			break;
		}
	}
	return b;
};

//处理获取元素内容 	  传入JS对象。
export function manageText(obj){
	var text="";
	if(findvar(obj.tagName,['INS', 'A', 'FONT', 'P', 'h4'])){
		if($(obj).children("script").length>0){
			return text;
		}
		if(obj.children.length>0 && obj.children[0].nodeType == 1){
			return text;
		}
		//检查display属性是否为none
		var dis = obj.currentStyle?obj.currentStyle.display/*ie*/:document.defaultView.getComputedStyle(obj,null).display;
		if(dis == "none"){return text;}
		//处理innerHTML内容，
		text=obj.innerHTML.replace(/<.+?>/g,'');		
		text=text.replace(/\s/g, '');
	//读取a标签中的title内容 如果A链接的子元素是img按下方图片处理
	}else if(obj.tagName == "A"&&!($(obj).find("img").is("img"))&&!($(obj).find("span").is("span"))){
		if(obj.title!=null&&obj.title.length!=""){
			text = obj.title.replace(/<.+?>/g,'');
		}else {
			text = obj.innerHTML.replace(/<.+?>/g,'');
		}
		text = "链接："+text;
	}else if(obj.tagName == "SELECT"){
		var selected = obj;
		for(var i=0;i<selected.options.length;i++){
			if(selected.options[i].selected){
//				text = selected.options[i].value;   //应该读文字不是value
				var opt = $(selected.options[i]).children()[0];
				if(opt!=null){
					text = opt.innerHTML;
				}
				text = "列表框："+text;
				break;
			}
		}
		//var selected = obj.selectedOptions[0].text;
		text = text.replace(/\s/g, '');
	}else if(obj.tagName == "INPUT"){
		var type = $(obj).attr("type");
		if(type == "hidden"){
			return text;
		}else{
			text=obj.value.replace(/\s/g, '');
			text = text.replace(/<.+?>/g,'');
			if(type=="text"){
				text = "文本输入框："+text;
			}else if(type=="radio"){
				text = "丹选按钮："+text;
			}else if(type=="image"){
				text = "图像式的提交按钮："+text;
			}else if(type=="checkbox"){
				text = "复选框："+text;
			}else if(type=="file"){
				text = "文件上传按钮："+text;
			}else if(type=="password"){
				text = "密码输入框："+text;
			}else if(type=="reset"){
				text = "重置按钮："+text;
			}else if(type=="submit"){
				text = "提交按钮："+text;
			}else if(type=="button"){
				text = "按钮："+text;
			}else{
				text = "文本输入框："+text;
			}
		}
	}else if(obj.tagName == "IMG"){
		if(obj.alt!=null&&obj.alt!=""&&obj.alt.replace(/\s/g, '') != "无意义图片"){
			text = obj.alt.replace(/\s/g, '');
			if($(obj).parents().is("a")){
				text = "图片链接："+text;
			}else{
				text = "图片："+text;
			}
			return text;
		}else{
			if($(obj).parents().is("a")){
				text = ($(obj).parents('a').attr("title")!=undefined)? $(obj).parents('a').attr("title") : "";
				text = "图片链接："+text.replace(/\s/g, '');
				return text;
			}
			return "图片";
		}
	}else if (obj.tagName == "OBJECT") {
		//alert(obj.title.replace(/\s/g, ''));
		text = obj.title.replace(/\s/g, '');
		text = "多媒体："+text;
		
	}else if(obj.tagName == "BUTTON"){
		if(obj.innerHTML!=null&&obj.innerHTML.length!=""){
			text = obj.innerHTML.replace(/<.+?>/g,'');
			text = "按钮："+text;
		}else if(obj.title!=null&&obj.title.length!=""){
			text = obj.title.replace(/<.+?>/g,'');
			text = "按钮："+text;
		}else{
			return "按钮";
		}
		return text;
	}else if(obj.tagName == "SPAN"){//针对在<a><img><span>工作动态</span></a>这种形式的链接的调整
		if($(obj).parents().is("a")) {
			if($(obj).parents('a').attr("title")!=undefined){
				text = $(obj).parents('a').attr("title");
			}else{
				text = obj.innerHTML.replace(/<.+?>/g,'');
			}
			text = "链接："+text;
		}
	}
	text = text.replace(/\|/g,'');
	text = text.replace(/\·/g,'');
	text = text.replace(/&lt;/g,'');
	text = text.replace(/&gt;/g,'');
	text = text.replace(/&nbsp;/g,'');
//	text = text.replace(/\-/g,'');
	text = text.replace(/\→/g,'');
	text = text.replace(/\.\.\./g,'');
	return text;
};

var base64KeyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
//将Ansi编码的字符串进行Base64编码
function encode64(input){
  var output = "";
	var chr1, chr2, chr3 = "";
	var enc1, enc2, enc3, enc4 = "";
	var i = 0;
	do {
		chr1 = input.charCodeAt(i++);
		chr2 = input.charCodeAt(i++);
		chr3 = input.charCodeAt(i++);
		enc1 = chr1 >> 2;
		enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
		enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
		enc4 = chr3 & 63;
		if (isNaN(chr2)) {
			enc3 = enc4 = 64;
		} else if (isNaN(chr3)) {
			enc4 = 64;
		}
		output = output + base64KeyStr.charAt(enc1) + base64KeyStr.charAt(enc2)
				+ base64KeyStr.charAt(enc3) + base64KeyStr.charAt(enc4);
		chr1 = chr2 = chr3 = "";
		enc1 = enc2 = enc3 = enc4 = "";
	} while (i < input.length);
	return output;
};
//将Base64编码字符串转换成Ansi编码的字符串
function decode64(input) {
	var output = "";
	var chr1, chr2, chr3 = "";
	var enc1, enc2, enc3, enc4 = "";
	var i = 0;

	if (input.length % 4 != 0) {
		return "";
	}
	var base64test = /[^A-Za-z0-9\+\/\=]/g;
	if (base64test.exec(input)) {
		return "";
	}
	do {
		enc1 = base64KeyStr.indexOf(input.charAt(i++));
		enc2 = base64KeyStr.indexOf(input.charAt(i++));
		enc3 = base64KeyStr.indexOf(input.charAt(i++));
		enc4 = base64KeyStr.indexOf(input.charAt(i++));
		chr1 = (enc1 << 2) | (enc2 >> 4);
		chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
		chr3 = ((enc3 & 3) << 6) | enc4;

		output = output + String.fromCharCode(chr1);
		if (enc3 != 64) {
			output += String.fromCharCode(chr2);
		}
		if (enc4 != 64) {
			output += String.fromCharCode(chr3);
		}
		chr1 = chr2 = chr3 = "";
		enc1 = enc2 = enc3 = enc4 = "";
	} while (i < input.length);
	return output;
};

function utf16to8(str) {
  var out, i, len, c;
  out = "";
  len = str.length;
  for(i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if ((c >= 0x0001) && (c <= 0x007F)) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
      out += String.fromCharCode(0x80 | ((c >>  6) & 0x3F));
      out += String.fromCharCode(0x80 | ((c >>  0) & 0x3F));
    } else {
      out += String.fromCharCode(0xC0 | ((c >>  6) & 0x1F));
      out += String.fromCharCode(0x80 | ((c >>  0) & 0x3F));
    }
  }
  return out;
};

function utf8to16(str) {
  var out, i, len, c;
  var char2, char3;
  out = "";
  len = str.length;
  i = 0;
  while(i < len) {
    c = str.charCodeAt(i++);
    switch(c >> 4) {
      case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
        // 0xxxxxxx
        out += str.charAt(i-1);
        break;
      case 12: case 13:
        // 110x xxxx   10xx xxxx
        char2 = str.charCodeAt(i++);
        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = str.charCodeAt(i++);
        char3 = str.charCodeAt(i++);
        out += String.fromCharCode(((c & 0x0F) << 12) |
        ((char2 & 0x3F) << 6) |
        ((char3 & 0x3F) << 0));
        break;
    }
  }
  return out;
};
export function base64E(arg){
	return encode64(utf16to8(arg));
};
export function base64D(arg){
	return utf8to16(decode64(arg));
};


// WEBPACK FOOTER //
// ./src/assets/wza/js/utils.js